import SwitchHallDropdown from "./SwitchHallDropdown";
import NotificationsDropdown from "./NotificationsDropdown";
import React, {useState} from "react";
import "assets/ExtraStyle.css";
import {useTypedSelector} from "helpers/reducers";
import {Hall} from "types/entities/Hall";
import Loader from "components/Loader";

interface HomeTrackProps {
    hall: Hall | undefined;
    halls: any[];
    onClick: React.MouseEventHandler | undefined;
    isOpen: boolean | undefined;
}

const HomeTrack = ({halls, hall, isOpen, onClick}: HomeTrackProps) => {
    if (!hall) {
        return <Loader />;
    }

    return (
        <div className="NavBarTop__center w-220 relative items-center justify-center flex">
            <div className={"p-4"} onClick={onClick}>
                {hall.name}
            </div>
            {isOpen && (
                <div className={"p-4 border border-gray-100"}>
                    {halls?.map((hall, index) => {
                        return (
                            <button key={index} className="w-full relative inline-block">
                                <span className={"text-lg font-medium"}>{hall.name}</span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
const AdminNavBarTop = () => {
    const profile = useTypedSelector(state => state.sessionState.profile);
    const profileHall = profile?.hall;
    const [isOpen, setIsOpen] = useState(false);
    const clickHandler = () => {
        setIsOpen(!isOpen);
    };
    const halls = [
        {
            id: 1,
            name: "Tempodrom Winterthur",
            image: "/img/tempodrom-winterthur.svg",
        },
        {
            id: 2,
            name: "Kartbahn Spreitenbach",
            image: "/img/kartbahn-logo.svg",
        },
    ];
    return (
        <div className="NavBarTop fixed inset-x-0 top-0 bottom-auto h-16 flex z-50 bg-white">
            <div className="NavBarTop__inner flex relative z-10 w-full ml-8 mr-8 h-full justify-center place-content-between">
                <div className="NavBarTop__left absolute left-0 right-auto inset-y-0 flex justify-start items-center">
                    <img src={"/img/bomboclaat.svg"} width={160} />
                </div>
                <div className="NavBarTop__center absolute left-auto right-auto inset-y-0 flex justify-start items-center">
                    <HomeTrack hall={profileHall} halls={halls} isOpen={isOpen} onClick={clickHandler} />
                </div>
                <div className="NavBarTop__right absolute left-auto right-0 bottom-0 top-0 flex justify-center">
                    <SwitchHallDropdown />
                    <NotificationsDropdown />
                </div>
            </div>
        </div>
    );
};
export default AdminNavBarTop;
